exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-collapse{width:100%}.custom-collapse_header{padding:8px;cursor:pointer;font-weight:700;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;color:#60769a;border-radius:8px}html.dark .custom-collapse_header{background-color:#283046;color:#fff}.custom-collapse_content{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d4d54bde","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./modules/Dashboard/Resources/assets/js/views/index.vue
// module id = 2Nvi
// module chunks = 0